var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})],1),_c('div',{staticClass:"mt-3 d-flex flex-wrap"},_vm._l((_vm.indicator),function(item,index){return _c('div',{key:index,staticClass:"d-flex align-items-center mr-4"},[_c('b-badge',{staticClass:"badge p-3 mr-2",style:({
					backgroundColor: item.color,
					display: 'inline-block',
				})}),_c('span',{staticClass:"h6 mt-2"},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }